/*
 * @Date: 2023-09-13 10:07:45
 * @LastEditors: furan NgeKaworu@gmail.com
 * @LastEditTime: 2025-05-08 14:52:43
 * @FilePath: /newwork-h5/src/main.js
 */
import Vue from 'vue'
import 'normalize.css/normalize.css'

import App from './App.vue'
import router from './router'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import isBetween from 'dayjs/plugin/isBetween'
import store from './store'
// import VConsole from 'vconsole'
import '@vant/touch-emulator'
import 'dayjs/locale/zh-cn' // 导入中文语言环境
import weekOfYear from 'dayjs/plugin/weekOfYear'
dayjs.extend(weekOfYear)
import '@/assets/styles/index.css'
import './permission.js'
import i18n from 'i18n'

console.log('%c当前版本：' + process.env.VUE_APP_VERSION, 'color:#1890ff')

Vue.config.productionTip = false
Vue.prototype.dayjs = dayjs
Vue.config.ignoredElements = ['wx-open-launch-weapp']
dayjs.extend(customParseFormat)
dayjs.extend(isBetween)

// if (process.env.VUE_APP_ENV !== 'prod') new VConsole()

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
